import { AppSearchBadge, AppSearchBox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useSearchTokens } from '@opportunities/list/-components/SearchBox/hooks/useSearchTokens'
import { useSearchBoxHandlers } from '@/hooks/useSearchBoxHandlers'
import { useNameResolutionMaps } from './hooks/useNameResolutionMaps'
import { opportunitySearchBadgeConfig } from './search-badge-config'
import type { SearchBoxProps } from './types'

/**
 * SearchBox - オポチュニティ検索ボックス
 *
 * 検索条件をパースしてバッジ形式で表示します。
 */
export function SearchBox({
  value,
  onChange,
  opportunities,
  opportunityStatuses,
  placeholder = '検索...',
  className,
  label,
  tooltipContent,
}: SearchBoxProps) {
  const maps = useNameResolutionMaps(opportunities, opportunityStatuses)
  const tokens = useSearchTokens(value, maps)
  const { inputValue, setInputValue, inputRef, removeToken, handleKeyDown } = useSearchBoxHandlers(
    value,
    onChange,
    tokens,
  )

  return (
    <AppSearchBox
      value={inputValue}
      onChange={setInputValue}
      onKeyDown={handleKeyDown}
      inputRef={inputRef}
      label={label}
      tooltipContent={tooltipContent}
      placeholder={tokens.length === 0 ? placeholder : ''}
      className={className}
    >
      {tokens.map((token, index) => (
        <AppSearchBadge
          key={`${token.raw}-${index}`}
          token={token}
          onRemove={removeToken}
          config={opportunitySearchBadgeConfig}
        />
      ))}
    </AppSearchBox>
  )
}
